import { useState } from "react";
import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroSection from "@/pages/home/components/HeroSection";
import GallerySection from "@/pages/home/components/GallerySection";
import UpdatesList from "@/pages/home/components/UpdatesList";
import ThemeCollections from "@/pages/home/components/ThemeCollections";
import CompareSection from "@/pages/home/components/CompareSection";
import DownloadCTA from "@/pages/home/components/DownloadCTA";
import FaqSection from "@/pages/home/components/FaqSection";
import SiteFooter from "@/pages/home/components/SiteFooter";
import DownloadModal from "@/pages/home/components/DownloadModal";

interface ModalState {
  open: boolean;
  title: string;
  desc: string;
}

const downloadDesc =
  "完整线索包按主题归档，包含暗网截图、网络信息与隐藏线索的索引，并附来源标注与原始片段对照结果。";

export default function Home() {
  const [modal, setModal] = useState<ModalState>({ open: false, title: "", desc: "" });

  const openDownload = () => setModal({ open: true, title: "下载完整线索包", desc: downloadDesc });

  const openEntry = (title: string) =>
    setModal({
      open: true,
      title,
      desc: "该条目目前为静态展示，下面是它包含的资料结构说明，正式内容请以页面索引为准。",
    });

  const closeModal = () => setModal((prev) => ({ ...prev, open: false }));

  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader onDownload={openDownload} />
      <main>
        <HeroSection onDownload={openDownload} />
        <GallerySection onOpen={openEntry} />
        <UpdatesList />
        <ThemeCollections onOpen={openEntry} />
        <CompareSection />
        <DownloadCTA onDownload={openDownload} />
        <FaqSection />
      </main>
      <SiteFooter />
      <DownloadModal
        open={modal.open}
        title={modal.title}
        desc={modal.desc}
        onClose={closeModal}
      />
    </div>
  );
}